// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.support-center-btn[data-v-1fa75705] {\r\n  background-color: white;\n}\n.support-center-btn[data-v-1fa75705]:hover {\r\n  background-color: white;\n}\n.collapsed > .when-open[data-v-1fa75705],\r\n.not-collapsed > .when-closed[data-v-1fa75705] {\r\n  display: none;\n}\r\n", ""]);
// Exports
module.exports = exports;
